module Shared {
    export var frendsUtilsApp = angular.module('frends-utils', ['ngAnimate', 'toastr', 'camelCaseToHuman'])
        .config(['$httpProvider', '$compileProvider', function ($httpProvider: ng.IHttpProvider, $compileProvider: ng.ICompileProvider) {

            //Angular debugging has to be enabled for process editor decision expression node to be rendered correctly. The debugging scope is used to notify codemirror that the popover has been opened.
            //$compileProvider.debugInfoEnabled(false);

            $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            $httpProvider.interceptors.push('httpInterceptor');
        }])
        .run(['$rootScope', function ($rootScope) {
            $rootScope.loadingSpinner = {
                optOutAutoSpin: false,
                manualSpin: false
            };
            $rootScope.$on('loadingspinner.manual.spin', function () {
                $rootScope.loadingSpinner.manualSpin = true;
                angular.element('#pageLoadSpinner').show();
            });
            $rootScope.$on('loadingspinner.manual.stop', function () {
                $rootScope.loadingSpinner.manualSpin = false;
                angular.element('#pageLoadSpinner').hide();
            });
            $rootScope.$on('loadingspinner.auto.spin', function () {
                if (!$rootScope.loadingSpinner.optOutAutoSpin) {
                    angular.element('#pageLoadSpinner').show();
                }
            });
            $rootScope.$on('loadingspinner.auto.stop', function () {
                if (!$rootScope.loadingSpinner.manualSpin) {
                    angular.element('#pageLoadSpinner').hide();
                }
            });
        }])
        .filter('humanize', ['$filter', function ($filter) {
            return function (s) {
                if (s) {
                    var camelCase = $filter('camelCaseToHuman');
                    return capitalizeLastWordIfId(camelCase(s, true));
                } else {
                    return s;
                }
            }

            function capitalizeLastWordIfId(s) {
                var n = s.split(" ");
                if (n[n.length - 1] === "id") {
                    n[n.length - 1] = n[n.length - 1].toUpperCase();
                }
                return n.join(" ");
            }
        }])
        .filter('localizeText', ['$filter', function ($filter) {
            return function (s, options) {
                var prefix = options && options.prefix || "";
                if (s) {
                    return FRENDS.Localizations[prefix + s] || s;
                } else {
                    return s;
                }
            }
        }])
        .filter('moment', [function () {
            return function (d) {
                if (d) {
                    return moment.utc(d).local().fromNow();
                } else {
                    return FRENDS.Localizations.Never;
                }
            };
        }])
        .filter('isoDateString', [function () {
            return function (d) {
                if (d) {
                    return moment.utc(d).toISOString();
                } else {
                    return FRENDS.Localizations.Never;
                }
            };
        }])
        .filter('toLocalTime', [function () {
            return function (d) {
                if (d) {
                    return moment.utc(d).local().calendar();
                } else {
                    return FRENDS.Localizations.Never;
                }
            };
        }])
        .filter('decodeUri', [function () {
            return function (uri) {
                if (uri) {
                    return decodeURI(uri);
                }
                return uri;
            }
        }])
        .filter('toJsonIfObject', [function () {
            return function (v) {
                if (_.isObject(v)) {
                    return angular.toJson(v, true);
                } else {
                    return v;
                }
            };
        }])
        .filter('toDetailedLocalTime', [function () {
            return function (d) {
                if (d) {
                    return moment.utc(d).local().format('YYYY-MM-DD HH:mm:ss');;
                } else {
                    return FRENDS.Localizations.Never;
                }
            };
        }])
        .filter('startFrom', function () {
            return function (input, start) {
                if (input != null) {
                    start = +start; //parse to int
                    return input.slice(start);
                }
                return input;
            }
        }).filter('highlight', function ($sce) {
            return function (text, phrase) {
                if (phrase)
                {
                    text = text.replace(new RegExp('(' + _.escapeRegExp(phrase) + ')', 'gi'),
                        '<span style="background-color: yellow;">$1</span>')
                }
                return $sce.trustAsHtml(text);

            }
        })
        .factory('httpInterceptor', ['$rootScope', 'notifications', function ($rootScope, notifications) {
            return {
                request: function (config) {
                    if (!config.disableSpinner) {
                        $rootScope.$broadcast("loadingspinner.auto.spin");
                    }
                    if (config.method !== "GET") {
                       config.headers['X-XSRF-Token'] = angular.element('input[name="__RequestVerificationToken"]').attr('value');
                    }
                    return config;
                },
                responseError: function (errorReason) {
                    if (errorReason) {
                        switch (errorReason.status) {
                            case 401:
                            case 403:
                                notifications.error(FRENDS.Localizations.Error_AccessDenied + " (" + errorReason.status + ")");
                                break;
                            default:
                                if (errorReason.data && errorReason.data.errorMessage) {
                                    notifications.error(errorReason.data.errorMessage);
                                } else {
                                    notifications.error(FRENDS.Localizations.Error_Generic + " (" + errorReason.status + ")");
                                }

                        }
                    } else {
                        notifications.error(FRENDS.Localizations.Error_Generic);
                    }
                    return errorReason;
                },
                response: function (response) {
                    $rootScope.$broadcast("loadingspinner.auto.stop");
                    if (response.data && response.data.success === false) {
                        notifications.error(response.data.errorMessage);
                    }
                    return response;
                }
            };
        }])
        .factory('notifications', ['$injector', 'toastrConfig', function ($injector, toastrConfig) {
            var defaultOptions = angular.extend({}, toastrConfig, {
                "timeOut": 2000,
                "extendedTimeOut": 1000
            });

            var stickyOptions = angular.extend({}, defaultOptions, {
                "closeButton": true,
                "timeOut": 0,
                "extendedTimeOut": 0,
                "sticky": true,
                "allowHtml": true
            });

            return {
                error: function (msg) {
                    var toastr = $injector.get('toastr');
                    toastr.error(msg, stickyOptions);
                },
                notify: function (msg) {
                    var toastr = $injector.get('toastr');
                    toastr.info(msg, defaultOptions);
                }
            };
        }])
        .factory('TagService', [function () {
            return {
                getTagsArray: function (tagString) {
                    return (_.isString(tagString) && !_.isEmpty(tagString)) ? tagString.split(",") : [];
                }
            };
        }])
        .directive('frendsSaveButtonDirtyChecker', [function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs, ngModel) {
                    var dirty = false;
                    element.addClass('animated');
                    scope.$watch(attrs.frendsSaveButtonDirtyChecker, function (newVal, oldVal) {
                        dirty = newVal;
                        if (newVal) {
                            element.removeClass('fadeOutDown').addClass('bounceInUp');
                        } else {
                            element.removeClass('bounceInUp').addClass('fadeOutDown');
                        }
                    }, true);

                    // ACC-5070: After saving, FireFox, IE, and Edge execute window.onbeforeunload before the scope.$watch callback.
                    // Calling this event manually changes the flag before onbeforeunload
                    scope.$on("reset.dirty.frends", function () {
                        dirty = false;
                    });

                    window.onbeforeunload = function () {
                        if (dirty) {
                            return FRENDS.Localizations.WarningUnsavedChanges;
                        }
                    };
                }
            };
        }])
        .directive('frendsOptOutLoadingSpinner', ['$rootScope', function ($rootScope) {
            return {
                restrict: 'EA',
                link: function () {
                    $rootScope.loadingSpinner.optOutAutoSpin = true;
                }
            };
        }])
        .directive('lowercasedModel', function () {
            // meks the model lowercased
            // original from http://stackoverflow.com/a/14425022
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, modelCtrl: any) {
                    modelCtrl.$parsers.push(function (input) {
                        var transformedInput = input.toLowerCase();

                        if (transformedInput != input) {
                            modelCtrl.$setViewValue(transformedInput);
                            modelCtrl.$render();
                        }

                        return transformedInput;
                    });
                }
            };
        }).directive('focusOn', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr: any) {
                    $scope.$watch($attr.focusOn, function (_focusVal) {
                        if (_focusVal) {
                            $timeout(function () {
                                $element[0].focus();
                            });
                        }
                    });
                }
            }
        });

    export function getEnumNames(e: any): string[] {
        // original from http://stackoverflow.com/a/21294925
        return _.filter(_.keys(e), v => isNaN(parseInt(v, 10)));// the keys are the non-integer ones
    }

}


